import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  BASE_PATH,
  DemonstrationAgendaItemResponse,
  DemonstrationUseCaseResponse,
} from '@frontend/shared-api';

@Injectable({
  providedIn: 'root',
})
export class ProviderDemonstrationService {
  private readonly http = inject(HttpClient);
  private readonly basePath = inject(BASE_PATH);

  getAgenda(tenderId: number): Observable<DemonstrationAgendaItemResponse[]> {
    const url = `${this.basePath ?? ''}/tenders/${tenderId}/rfd/agenda`;
    return this.http.get<DemonstrationAgendaItemResponse[]>(url);
  }

  getUseCases(tenderId: number): Observable<DemonstrationUseCaseResponse[]> {
    const url = `${this.basePath ?? ''}/tenders/${tenderId}/rfd/use-cases`;
    return this.http.get<DemonstrationUseCaseResponse[]>(url);
  }
}
